import { Reveal } from "./Reveal";

export default function PageHeader({ overline, title, subtitle }) {
  return (
    <section className="relative overflow-hidden pt-40 pb-16">
      <div className="absolute inset-0 grid-overlay opacity-30" />
      <div className="orb h-[300px] w-[300px] bg-blue-600/15 left-[10%] top-0" />
      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          {overline && <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">{overline}</p>}
          <h1 className="mt-4 font-display text-5xl font-semibold tracking-tighter sm:text-6xl lg:text-7xl">
            {title}
          </h1>
          {subtitle && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-400">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
